import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  FormGroup,
  Table,
  Input,
  Button,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { get_file } from "connection/api";

// Actions
import { ticketList, ticketFilter } from "store/billing/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";
import Pagination2 from "components/Common/Pagination2";

const ConfiscationList = (props) => {
  const URL = process.env.REACT_APP_URL;
  const dispatch = useDispatch();
  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth() + 1;
  const anio = fechaActual.getFullYear();

  const fechaString = `${anio}-${mes < 10 ? "0" + mes : mes}-${
    dia < 10 ? "0" + dia : dia
  }`;

  useEffect(() => {
    dispatch(
      ticketFilter(
        `?search=&status=&created_date_after=${fechaString}&created_date_before=${fechaString}`
      )
    );
  }, []);

  const [search, setSearch] = useState("");
  const [createdDateRange, setCreatedDateRange] = useState([
    fechaActual,
    fechaActual,
  ]);
  const [state, setState] = useState("");

  const onChange1 = (e) => {
    setSearch(e.target.value);
  };

  const onChange2 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const onClick = async () => {
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    const excel_url = `${URL}report/decomiso_excel/?status=${state}&created_date_after=${date_1}&created_date_before=${date_2}`;
    try {
      const response = await get_file(excel_url);
      console.log(response);
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = date_1 && date_2 ? `Decomisos_${date_1}_${date_2}.xlsx` : `Decomisos.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar el archivo", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    dispatch(
      ticketFilter(
        `?search=${search}&status=${state}&created_date_after=${date_1}&created_date_before=${date_2}`
      )
    );
  };

  const resetFilter = () => {
    setSearch("");
    setCreatedDateRange("");
    setState("");
    dispatch(
      ticketFilter(
        `?search=&status=&created_date_after=${fechaString}&created_date_before=${fechaString}`
      )
    );
  };

  const params = {
    count: props.tickets.count,
    next: props.tickets.next,
    previous: props.tickets.previous,
    results: props.tickets.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Decomisos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Decomisos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row className="justify-content-md-start">
                    <Col>
                      <Form onSubmit={onSubmit}>
                        <Row className="justify-content-md-start">
                          <Col lg={2}>
                            <p className="mb-1 font-size-13">
                              Fecha de ingreso:
                            </p>
                            <InputGroup>
                              <Flatpickr
                                className="form-control"
                                placeholder="dd/mm/aaaa"
                                value={createdDateRange}
                                onChange={onChange2}
                                options={{
                                  mode: "range",
                                  dateFormat: "d/m/Y",
                                  locale: Spanish,
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col lg={6} className="mt-4">
                            <Button color="light" type="submit">
                              Aplicar
                            </Button>
                            <Button
                              className="ms-2"
                              color="secondary"
                              onClick={resetFilter}
                            >
                              Borrar
                            </Button>
                            <Button
                              className="ms-2"
                              color="success"
                              type="button"
                              onClick={onClick}
                            >
                              Exportar
                            </Button>
                          </Col>
                          <Col lg={4} className="search-box mt-4">
                            <InputGroup>
                              <Input
                                type="text"
                                className="form-control"
                                name="search"
                                id="search"
                                value={search}
                                onChange={onChange1}
                                placeholder="Ticket, cliente..."
                              />
                              <i className="bx bx-search-alt search-icon" />
                              <Button color="primary" onClick={resetFilter}>
                                <span className=" bx bx-x fa-lg align-middle"></span>
                              </Button>
                            </InputGroup>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    <div
                      className="table-responsive"
                      style={{
                        textAlign: "center",
                        overflow: "visible",
                      }}
                    >
                      <Table
                        className="table table-striped table-borderless align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Código cliente</th>
                            <th>Nombre cliente</th>
                            <th>Fecha ingreso</th>
                            <th>Cantidad Bovinos</th>
                            <th>Decomiso</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((ticket, idx) => (
                            <tr key={idx}>
                              {ticket.state !== "cancelado" && (
                                <>
                                  <th scope="row">{ticket.consecutive}</th>
                                  <td>{ticket.client.code}</td>
                                  <td>{ticket.client.full_name}</td>
                                  <td>{ticket.created_date}</td>
                                  <td>{ticket.animal_number}</td>
                                  {ticket.confiscation === false ? (
                                    <>
                                      <td>
                                        <Link
                                          className="btn btn-success btn-sm waves-effect waves-light"
                                          to={`/confiscations/create/${ticket.code}`}
                                        >
                                          Generar
                                        </Link>
                                      </td>
                                      <td>-</td>
                                    </>
                                  ) : (
                                    <>
                                      <td>
                                        <UncontrolledButtonDropdown className="btn-group">
                                          <DropdownToggle
                                            color="primary"
                                            className="btn btn-primary btn-sm"
                                          >
                                            Ver{" "}
                                            <i className="mdi mdi-chevron-down"></i>
                                          </DropdownToggle>
                                          <DropdownMenu>
                                            <DropdownItem
                                              onClick={() =>
                                                window.open(
                                                  `${URL}report/decomiso_pdf/${ticket.code}/`
                                                )
                                              }
                                            >
                                              POS
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                      </td>
                                      <td>
                                        <Link to={``}>
                                          <span className="bx bx-edit fa-lg align-middle"></span>
                                        </Link>
                                      </td>
                                    </>
                                  )}
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination2
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="tickets/"
                      filterFunction={ticketFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, tickets } = state.Billing;
  return { error, loading, tickets };
};

export default withRouter(connect(mapStateToProps)(ConfiscationList));
